import React from "react";

import Box from "components/common/Box";
import Text from "components/common/Text";

const ProductGrid = ({ products, classes }) => (
  <Box className={classes.productGrid}>
    {products.map((product) => (
      <Box key={product.title} className={classes.productCard}>
        {product.badge ? (
          <Text
            className={`${classes.productBadge} ${
              product.badgeVariant === "cyan"
                ? classes.productBadgeCyan
                : classes.productBadgePurple
            }`}
          >
            {product.badge}
          </Text>
        ) : null}
        {product.icon ? (
          <Box
            component="img"
            src={product.icon}
            alt=""
            className={classes.productIcon}
            draggable={false}
          />
        ) : (
          <Box
            className={classes.productIconSlot}
            sx={{ backgroundColor: product.iconSlotColor || "#E8F0FE" }}
            aria-hidden
          />
        )}
        <Box className={classes.productText}>
          <Text className={classes.productTitle}>{product.title}</Text>
          <Text className={classes.productDescription}>
            {product.description}
          </Text>
        </Box>
      </Box>
    ))}
  </Box>
);

export default ProductGrid;
